import styled from 'styled-components';

interface TabsStyledProps {
  placement?: string;
}

const TabsStyled = styled.div<TabsStyledProps>(({ theme, placement }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: placement === 'center' ? 'space-between' : '',
  scrollBarWidth: 'none',
  boxSizing: 'border-box',
  overflowX: 'auto',
  '::-webkit-scrollbar': {
    display: 'none',
  },
  borderBottom: `1px solid ${theme.color.wfGrey300}`,
}));

export { TabsStyled };
